// globals
import '../globals/webpackPublicPath';

// polyfills
import '../polyfills/index';

// loads vue components async and inits
import vueComponents from '../vue/_index';
vueComponents();
